import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../core/models/generic-models';
import { IValidateGovIdPassortRequest, IValidateGovIdPassortResponse } from '../models/validate-gov-id-passport.model';

export const loadValidateGovIdPassports = createAction(
  '[ValidateGovIdPassport] Load ValidateGovIdPassports',
  props<{ request: IValidateGovIdPassortRequest }>()
);

export const loadValidateGovIdPassportsSuccess = createAction(
  '[ValidateGovIdPassport] Load ValidateGovIdPassports Success',
  props<{ response: IValidateGovIdPassortResponse }>()
);

export const loadValidateGovIdPassportsFailure = createAction(
  '[ValidateGovIdPassport] Load ValidateGovIdPassports Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

export const clearValidateGovIdPassportsFailure = createAction('[ValidateGovIdPassport] Clear ValidateGovIdPassports Failure');
